import { Box } from '@mui/material';
import { custodianSteps } from '../../settings/appConfig';
import CustodianMainInfo from './Components/CustodianMainInfo';
import { useState } from 'react';
import FacilityType from './Components/FacilityType';
import CustodianDetails from './Components/CustodianDetails';
import Dropdown from '../../Models/Locations/dropdown';

export default function CustodiansWizardContent({
  mainInfoForm,
  custodianTypes,
  paymentMethods,
  states,
  phoneTypes,
  portalTypes,
  sourceTypes,
  recordTypes,
  serveMethods,
  supportedOrderTypes,
  timeZones,
  departmentFileTypes,
  days,
  copyCustodianAddress,
  followUpMethods
}: Readonly<{
  mainInfoForm: any;
  custodianTypes: any[];
  paymentMethods: any[];
  states: any[];
  phoneTypes: any[];
  sourceTypes: any[];
  portalTypes: any[];
  recordTypes: any[];
  serveMethods: any[];
  supportedOrderTypes: any[];
  timeZones: any[];
  departmentFileTypes: any[];
  days: any[];
  copyCustodianAddress?: (key: string) => void;
  followUpMethods: Dropdown[];
  
}>) {
  const [isFacility, setIsFacility] = useState(false);
  const [isCustodian, setIsCustodian] = useState(false);
  return (
    <Box sx={{ width: '100%' }}>
      <Box>
        {(
          <form
            name={custodianSteps.mainInfo}
            onSubmit={mainInfoForm.handleSubmit}
          >
            <CustodianMainInfo
              formik={mainInfoForm}
              custodianTypes={custodianTypes}
              timeZones={timeZones}
              phoneTypes={phoneTypes}
              portalTypes={portalTypes}
              sourceTypes={sourceTypes}
              states={states}
              isFacility={isFacility}
              setIsFacility={setIsFacility}
              isCustodian={isCustodian}
              setIsCustodian={setIsCustodian}
              copyCustodianAddress={copyCustodianAddress}
            />
          </form>
        )}
        {isFacility && (
          <FacilityType formik={mainInfoForm} custodianTypes={custodianTypes} />
        )}
        {isCustodian && (
          <form
            name={custodianSteps.mainInfo}
            onSubmit={mainInfoForm.handleSubmit}
          >
            <CustodianDetails
            recordTypes={recordTypes} 
            formik={mainInfoForm}
            timeZones={timeZones}
            days={days}
            serveMethods={serveMethods}
            departmentFileTypes={departmentFileTypes}
            states={states}
            paymentMethods={paymentMethods}
            orderTypes={supportedOrderTypes}
            followUpMethods={followUpMethods}
            />
          </form>
        )}
      </Box>
    </Box>
  );
}
